import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    markReadUrl: String
  }

  markRead() {
    if (!this.hasMarkReadUrlValue) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    if (!csrfToken) return

    fetch(this.markReadUrlValue, {
      method: "PATCH",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
      .then((response) => response.text())
      .then((html) => {
        if (window.Turbo?.renderStreamMessage) {
          window.Turbo.renderStreamMessage(html)
        }
      })
      .catch(() => {})
  }
}
